import p from "./_common.js";
import k from "../../_styles/common/light.js";
import { changeColor as x } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function f(d) {
  const {
    baseColor: l,
    inputColorDisabled: a,
    cardColor: c,
    modalColor: i,
    popoverColor: b,
    textColorDisabled: e,
    borderColor: r,
    primaryColor: o,
    textColor2: s,
    fontSizeSmall: t,
    fontSizeMedium: C,
    fontSizeLarge: h,
    borderRadiusSmall: n,
    lineHeight: m
  } = d;
  return Object.assign(Object.assign({}, p), {
    labelLineHeight: m,
    fontSizeSmall: t,
    fontSizeMedium: C,
    fontSizeLarge: h,
    borderRadius: n,
    color: l,
    colorChecked: o,
    colorDisabled: a,
    colorDisabledChecked: a,
    colorTableHeader: c,
    colorTableHeaderModal: i,
    colorTableHeaderPopover: b,
    checkMarkColor: l,
    checkMarkColorDisabled: e,
    checkMarkColorDisabledChecked: e,
    border: `1px solid ${r}`,
    borderDisabled: `1px solid ${r}`,
    borderDisabledChecked: `1px solid ${r}`,
    borderChecked: `1px solid ${o}`,
    borderFocus: `1px solid ${o}`,
    boxShadowFocus: `0 0 0 2px ${x(o, {
      alpha: 0.3
    })}`,
    textColor: s,
    textColorDisabled: e
  });
}
const g = {
  name: "Checkbox",
  common: k,
  self: f
}, S = g;
export {
  S as default,
  f as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/checkbox/styles/light.js
// module id = 458
// module chunks = 41